module.exports = "<div id=main> <div class=not-found> <img src=http://echarts.baidu.com/images/404.png alt=404> <div class=text>非常抱歉，您所访问的网页找不到了！您可以选择 <a href=javascript:; class=link v-link=\"{name:'home'}\">返回首页</a> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
 ** module id = 130
 ** module chunks = 1
 **/